<script lang="ts">
					import { defineComponent } from 'vue'
					export default defineComponent({
						name: "undefined"
					})
				</script><template>
	<el-config-provider :locale="locale">
		<router-view :key="localeKey" />
	</el-config-provider>
</template>

<script lang="ts" setup>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import zhTW from "element-plus/lib/locale/lang/zh-tw";
import en from "element-plus/lib/locale/lang/en";
import es from "element-plus/lib/locale/lang/es";
import ko from "element-plus/lib/locale/lang/ko";
import ja from "element-plus/lib/locale/lang/ja";
import { useTranslation } from "i18next-vue";
import { computed, watch } from "vue";
import { useBase } from "/$/base";
import { getOemSetting } from "/@//utils/oem";
import { normalizeLang } from "/@/utils/normalizeLang";

import * as i18n from "./utils/i18n";
const { i18next, t } = useTranslation();
i18n.set(t);
const { lang } = useBase();

const localeKey = computed(() => `${lang.info}-${lang.revision}`);

function transTitle() {
	if (getOemSetting("brand_name")) {
		document.title = getOemSetting("brand_name");
	} else {
		document.title = i18next.t("website_title");
	}
}

watch(
	() => i18next.language,
	(val: any) => {
		const langKey = normalizeLang(val);
		if (langKey) {
			lang.set(langKey);
		}
	},
	{ immediate: true }
);

const locale = computed(() => {
	const currentLang = normalizeLang(i18next.language) || "zh-CN";
	switch (currentLang) {
		case "zh-CN":
			return zhCn;
		case "en":
			return en;
		case "ko":
			return ko;
		case "es":
			return es;
		case "zh-TW":
		case "zh-HK":
			return zhTW;
		case "ja":
			return ja;
		default:
			return zhCn;
	}
});
</script>
<style lang="scss" src="./assets/css/index.scss"></style>
